/**
 * Analytics del widget: inyección de gtag y envío de eventos para embudo de conversión.
 * Eventos del embudo: session_start, view_item, add_to_cart, begin_checkout, purchase.
 */

const GA_MEASUREMENT_ID = 'G-BBXS9LNLQS';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * Inyecta el script de gtag si no existe y ejecuta gtag('config', ID) una vez.
 * No envía evento de "widget cargado".
 */
export function initWidgetAnalytics(): void {
  if (typeof window === 'undefined') return;

  const setupGtag = (): void => {
    window.dataLayer = window.dataLayer ?? [];
    const gtag = (...args: unknown[]): void => {
      window.dataLayer?.push(args);
    };
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID);
  };

  const existingGtag = document.querySelector(
    `script[src*="googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}"]`
  );

  if (!existingGtag) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }

  setupGtag();
}

/**
 * Envía un evento a GA para el embudo de conversión.
 */
export function trackWidgetEvent(
  eventName: string,
  params?: Record<string, string | boolean>
): void {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', eventName, params ?? {});
}
